import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  FETCH_REPAIR_ORDER_TEMPLATES: createSagaAction('FETCH_REPAIR_ORDER_TEMPLATES')
}

// Action Creators
export const actions = {
  fetchRepairOrderTemplates: () => ({
    type: constants.FETCH_REPAIR_ORDER_TEMPLATES.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.FETCH_REPAIR_ORDER_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.FETCH_REPAIR_ORDER_TEMPLATES.SUCCESS:
      return {
        ...state,
        repairOrderTemplates: action.payload
      }
    case constants.FETCH_REPAIR_ORDER_TEMPLATES.FAILED:
      return {
        error: action.message
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteRepairOrderActions.js